"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisionOfKatajenAbilityHandler = exports.VisionOfKatajenActorAbilityFactory = exports.VisionOfKatajenAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Bleeding_1 = require("../../core/effects/core/Bleeding");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
class VisionOfKatajenAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.VisionOfKatajen;
        this.__typeName = "VisionOfKatajen";
    }
}
exports.VisionOfKatajenAbilityArgs = VisionOfKatajenAbilityArgs;
let VisionOfKatajenActorAbilityFactory = class VisionOfKatajenActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("VisionOfKatajen", "OneEnemies", 3);
    }
};
VisionOfKatajenActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("VisionOfKatajen")
], VisionOfKatajenActorAbilityFactory);
exports.VisionOfKatajenActorAbilityFactory = VisionOfKatajenActorAbilityFactory;
let VisionOfKatajenAbilityHandler = class VisionOfKatajenAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        const targets = Array((0, Random_1.random)(2, 5)).fill(0).map(() => selectedEnemy);
        const leechId = container.registerEventHandlerScript(ability.invokerId, EventType_1.EventType.DamageDealt, Schedule_1.Schedule.Unlimited, "Effect_Leech_OnDamageDealt", {
            percent: 25,
            target: Target_1.Target.AllAllies
        });
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            targets: targets.map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 30)
                ]
            })),
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new Bleeding_1.BleedingEffectArgs("Power", 10),
                    sequence
                });
            },
        });
        container.cancelEventHandler(leechId);
    }
};
VisionOfKatajenAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.VisionOfKatajen)
], VisionOfKatajenAbilityHandler);
exports.VisionOfKatajenAbilityHandler = VisionOfKatajenAbilityHandler;
